import wixWindow from 'wix-window';
import wixLocation from 'wix-location';

const spElementIds = ['text109', 'text111', 'image7'];

$w.onReady(function () {
	//TODO: write your page related code here...
//   $w("#container2").onClick(() => wixLocation.to('http://www.mind-body.jp'))
  if(wixWindow.formFactor === "Mobile"){
    spElementIds.forEach(e => {
	  const element = $w("#" + e)
	  if(element) {
		element.style.display = 'none';
	  }
	})
  }
});

export function text27_click(event) {
	//Add your code for this event here: 
}
